module.exports = __webpack_public_path__ + "static/media/ertec2.77a21e87.jpg";